// source: apigateway/service/search.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.service.Category', null, global);
goog.exportSymbol('proto.service.ConditionOption', null, global);
goog.exportSymbol('proto.service.ConditionPrice', null, global);
goog.exportSymbol('proto.service.ProviderData', null, global);
goog.exportSymbol('proto.service.RatingData', null, global);
goog.exportSymbol('proto.service.RecommendServicesReply', null, global);
goog.exportSymbol('proto.service.RecommendServicesRequest', null, global);
goog.exportSymbol('proto.service.SearchServiceCondition', null, global);
goog.exportSymbol('proto.service.SearchServiceReply', null, global);
goog.exportSymbol('proto.service.SearchServiceRequest', null, global);
goog.exportSymbol('proto.service.SearchServiceResult', null, global);
goog.exportSymbol('proto.service.ServiceData', null, global);
goog.exportSymbol('proto.service.ServiceImageData', null, global);
goog.exportSymbol('proto.service.ServiceMovieData', null, global);
goog.exportSymbol('proto.service.ServicePrData', null, global);
goog.exportSymbol('proto.service.SubCategory', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.SearchServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.SearchServiceRequest.repeatedFields_, null);
};
goog.inherits(proto.service.SearchServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.SearchServiceRequest.displayName = 'proto.service.SearchServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.SearchServiceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.SearchServiceReply.repeatedFields_, null);
};
goog.inherits(proto.service.SearchServiceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.SearchServiceReply.displayName = 'proto.service.SearchServiceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.SearchServiceResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.SearchServiceResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.SearchServiceResult.displayName = 'proto.service.SearchServiceResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ServiceData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.ServiceData.repeatedFields_, null);
};
goog.inherits(proto.service.ServiceData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ServiceData.displayName = 'proto.service.ServiceData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ProviderData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.ProviderData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ProviderData.displayName = 'proto.service.ProviderData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ServicePrData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.ServicePrData.repeatedFields_, null);
};
goog.inherits(proto.service.ServicePrData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ServicePrData.displayName = 'proto.service.ServicePrData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ServiceImageData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.ServiceImageData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ServiceImageData.displayName = 'proto.service.ServiceImageData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ServiceMovieData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.ServiceMovieData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ServiceMovieData.displayName = 'proto.service.ServiceMovieData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.RatingData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.RatingData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.RatingData.displayName = 'proto.service.RatingData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.SearchServiceCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.SearchServiceCondition.repeatedFields_, null);
};
goog.inherits(proto.service.SearchServiceCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.SearchServiceCondition.displayName = 'proto.service.SearchServiceCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ConditionOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.ConditionOption.repeatedFields_, null);
};
goog.inherits(proto.service.ConditionOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ConditionOption.displayName = 'proto.service.ConditionOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.ConditionPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.ConditionPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.ConditionPrice.displayName = 'proto.service.ConditionPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.Category = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.Category.repeatedFields_, null);
};
goog.inherits(proto.service.Category, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.Category.displayName = 'proto.service.Category';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.SubCategory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.SubCategory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.SubCategory.displayName = 'proto.service.SubCategory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.RecommendServicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.service.RecommendServicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.RecommendServicesRequest.displayName = 'proto.service.RecommendServicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.service.RecommendServicesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.service.RecommendServicesReply.repeatedFields_, null);
};
goog.inherits(proto.service.RecommendServicesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.service.RecommendServicesReply.displayName = 'proto.service.RecommendServicesReply';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.SearchServiceRequest.repeatedFields_ = [29,30,31,32,33,34,35,36,37,41,42,43,44,48];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.SearchServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.service.SearchServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.SearchServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    serviceClass: jspb.Message.getFieldWithDefault(msg, 4, ""),
    keyword: jspb.Message.getFieldWithDefault(msg, 5, ""),
    priceMin: jspb.Message.getFieldWithDefault(msg, 6, 0),
    priceMax: jspb.Message.getFieldWithDefault(msg, 7, 0),
    categoryId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    sortBy: jspb.Message.getFieldWithDefault(msg, 9, ""),
    deliveryAverage: jspb.Message.getFieldWithDefault(msg, 10, ""),
    forceExclusion: jspb.Message.getFieldWithDefault(msg, 11, ""),
    publishedOnly: jspb.Message.getFieldWithDefault(msg, 12, ""),
    proFlag: jspb.Message.getFieldWithDefault(msg, 13, ""),
    proPriorityDisplay: jspb.Message.getFieldWithDefault(msg, 14, ""),
    customizeFlag: jspb.Message.getFieldWithDefault(msg, 15, ""),
    shipmentFlag: jspb.Message.getFieldWithDefault(msg, 16, ""),
    identificationFlag: jspb.Message.getFieldWithDefault(msg, 17, ""),
    ndaConclusionFlag: jspb.Message.getFieldWithDefault(msg, 18, ""),
    reservationAvailableFlag: jspb.Message.getFieldWithDefault(msg, 19, ""),
    includeNgService: jspb.Message.getFieldWithDefault(msg, 20, ""),
    excludeFullCorrespondence: jspb.Message.getFieldWithDefault(msg, 21, ""),
    videoServiceFlag: jspb.Message.getFieldWithDefault(msg, 22, ""),
    availableOrder: jspb.Message.getFieldWithDefault(msg, 23, ""),
    loginDays: jspb.Message.getFieldWithDefault(msg, 24, 0),
    fixLimitMin: jspb.Message.getFieldWithDefault(msg, 25, 0),
    proposalLimitMin: jspb.Message.getFieldWithDefault(msg, 26, 0),
    unitPriceMin: jspb.Message.getFieldWithDefault(msg, 27, 0),
    unitPriceMax: jspb.Message.getFieldWithDefault(msg, 28, 0),
    providerStatusesList: (f = jspb.Message.getRepeatedField(msg, 29)) == null ? undefined : f,
    styleIdsList: (f = jspb.Message.getRepeatedField(msg, 30)) == null ? undefined : f,
    contentIdsList: (f = jspb.Message.getRepeatedField(msg, 31)) == null ? undefined : f,
    genreIdsList: (f = jspb.Message.getRepeatedField(msg, 32)) == null ? undefined : f,
    usageIdsList: (f = jspb.Message.getRepeatedField(msg, 33)) == null ? undefined : f,
    occupationIdsList: (f = jspb.Message.getRepeatedField(msg, 34)) == null ? undefined : f,
    industryIdsList: (f = jspb.Message.getRepeatedField(msg, 35)) == null ? undefined : f,
    languageIdsList: (f = jspb.Message.getRepeatedField(msg, 36)) == null ? undefined : f,
    fileTypeIdsList: (f = jspb.Message.getRepeatedField(msg, 37)) == null ? undefined : f,
    layout: jspb.Message.getFieldWithDefault(msg, 38, ""),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 39, 0),
    masterCategoryTypeId: jspb.Message.getFieldWithDefault(msg, 40, 0),
    techniqueIdsList: (f = jspb.Message.getRepeatedField(msg, 41)) == null ? undefined : f,
    paperSizeIdsList: (f = jspb.Message.getRepeatedField(msg, 42)) == null ? undefined : f,
    baseScopeIdsList: (f = jspb.Message.getRepeatedField(msg, 43)) == null ? undefined : f,
    sexIdsList: (f = jspb.Message.getRepeatedField(msg, 44)) == null ? undefined : f,
    businessFlag: jspb.Message.getBooleanFieldWithDefault(msg, 45, false),
    providerLevels: jspb.Message.getFieldWithDefault(msg, 46, 0),
    serviceKind: jspb.Message.getFieldWithDefault(msg, 47, ""),
    providerLevelIdsList: (f = jspb.Message.getRepeatedField(msg, 48)) == null ? undefined : f,
    certificationDivinationPriorityDisplay: jspb.Message.getFieldWithDefault(msg, 49, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.SearchServiceRequest}
 */
proto.service.SearchServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.SearchServiceRequest;
  return proto.service.SearchServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.SearchServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.SearchServiceRequest}
 */
proto.service.SearchServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceClass(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriceMin(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriceMax(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategoryId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryAverage(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setForceExclusion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedOnly(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setProFlag(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setProPriorityDisplay(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomizeFlag(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setShipmentFlag(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationFlag(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setNdaConclusionFlag(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservationAvailableFlag(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setIncludeNgService(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcludeFullCorrespondence(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoServiceFlag(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvailableOrder(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoginDays(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFixLimitMin(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProposalLimitMin(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnitPriceMin(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnitPriceMax(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.addProviderStatuses(value);
      break;
    case 30:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setStyleIdsList(value);
      break;
    case 31:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setContentIdsList(value);
      break;
    case 32:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setGenreIdsList(value);
      break;
    case 33:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUsageIdsList(value);
      break;
    case 34:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOccupationIdsList(value);
      break;
    case 35:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setIndustryIdsList(value);
      break;
    case 36:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setLanguageIdsList(value);
      break;
    case 37:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setFileTypeIdsList(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setLayout(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryTypeId(value);
      break;
    case 41:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setTechniqueIdsList(value);
      break;
    case 42:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setPaperSizeIdsList(value);
      break;
    case 43:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBaseScopeIdsList(value);
      break;
    case 44:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSexIdsList(value);
      break;
    case 45:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusinessFlag(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProviderLevels(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceKind(value);
      break;
    case 48:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setProviderLevelIdsList(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificationDivinationPriorityDisplay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.SearchServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.SearchServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.SearchServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getServiceClass();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPriceMin();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPriceMax();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDeliveryAverage();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getForceExclusion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPublishedOnly();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getProFlag();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getProPriorityDisplay();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCustomizeFlag();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getShipmentFlag();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getIdentificationFlag();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getNdaConclusionFlag();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getReservationAvailableFlag();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getIncludeNgService();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getExcludeFullCorrespondence();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getVideoServiceFlag();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAvailableOrder();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getLoginDays();
  if (f !== 0) {
    writer.writeInt32(
      24,
      f
    );
  }
  f = message.getFixLimitMin();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getProposalLimitMin();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getUnitPriceMin();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getUnitPriceMax();
  if (f !== 0) {
    writer.writeInt32(
      28,
      f
    );
  }
  f = message.getProviderStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      29,
      f
    );
  }
  f = message.getStyleIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      30,
      f
    );
  }
  f = message.getContentIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      31,
      f
    );
  }
  f = message.getGenreIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      32,
      f
    );
  }
  f = message.getUsageIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      33,
      f
    );
  }
  f = message.getOccupationIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      34,
      f
    );
  }
  f = message.getIndustryIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      35,
      f
    );
  }
  f = message.getLanguageIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      36,
      f
    );
  }
  f = message.getFileTypeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      37,
      f
    );
  }
  f = message.getLayout();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      39,
      f
    );
  }
  f = message.getMasterCategoryTypeId();
  if (f !== 0) {
    writer.writeInt32(
      40,
      f
    );
  }
  f = message.getTechniqueIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      41,
      f
    );
  }
  f = message.getPaperSizeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      42,
      f
    );
  }
  f = message.getBaseScopeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      43,
      f
    );
  }
  f = message.getSexIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      44,
      f
    );
  }
  f = message.getBusinessFlag();
  if (f) {
    writer.writeBool(
      45,
      f
    );
  }
  f = message.getProviderLevels();
  if (f !== 0) {
    writer.writeInt32(
      46,
      f
    );
  }
  f = message.getServiceKind();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getProviderLevelIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      48,
      f
    );
  }
  f = message.getCertificationDivinationPriorityDisplay();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
};


/**
 * optional string search_type = 1;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getSearchType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setSearchType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string service_class = 4;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getServiceClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setServiceClass = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string keyword = 5;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 price_min = 6;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getPriceMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPriceMin = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 price_max = 7;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getPriceMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPriceMax = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 category_id = 8;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string sort_by = 9;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string delivery_average = 10;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getDeliveryAverage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setDeliveryAverage = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string force_exclusion = 11;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getForceExclusion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setForceExclusion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string published_only = 12;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getPublishedOnly = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPublishedOnly = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string pro_flag = 13;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getProFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string pro_priority_display = 14;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getProPriorityDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProPriorityDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string customize_flag = 15;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getCustomizeFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setCustomizeFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string shipment_flag = 16;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getShipmentFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setShipmentFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string identification_flag = 17;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getIdentificationFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setIdentificationFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string nda_conclusion_flag = 18;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getNdaConclusionFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setNdaConclusionFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string reservation_available_flag = 19;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getReservationAvailableFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setReservationAvailableFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string include_ng_service = 20;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getIncludeNgService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setIncludeNgService = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string exclude_full_correspondence = 21;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getExcludeFullCorrespondence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setExcludeFullCorrespondence = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string video_service_flag = 22;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getVideoServiceFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setVideoServiceFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string available_order = 23;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getAvailableOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setAvailableOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional int32 login_days = 24;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getLoginDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setLoginDays = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 fix_limit_min = 25;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getFixLimitMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setFixLimitMin = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int32 proposal_limit_min = 26;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getProposalLimitMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProposalLimitMin = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int32 unit_price_min = 27;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getUnitPriceMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setUnitPriceMin = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional int32 unit_price_max = 28;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getUnitPriceMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setUnitPriceMax = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * repeated string provider_statuses = 29;
 * @return {!Array<string>}
 */
proto.service.SearchServiceRequest.prototype.getProviderStatusesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 29));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProviderStatusesList = function(value) {
  return jspb.Message.setField(this, 29, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addProviderStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 29, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearProviderStatusesList = function() {
  return this.setProviderStatusesList([]);
};


/**
 * repeated int32 style_ids = 30;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getStyleIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 30));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setStyleIdsList = function(value) {
  return jspb.Message.setField(this, 30, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addStyleIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 30, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearStyleIdsList = function() {
  return this.setStyleIdsList([]);
};


/**
 * repeated int32 content_ids = 31;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getContentIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 31));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setContentIdsList = function(value) {
  return jspb.Message.setField(this, 31, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 31, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearContentIdsList = function() {
  return this.setContentIdsList([]);
};


/**
 * repeated int32 genre_ids = 32;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getGenreIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 32));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setGenreIdsList = function(value) {
  return jspb.Message.setField(this, 32, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addGenreIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 32, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearGenreIdsList = function() {
  return this.setGenreIdsList([]);
};


/**
 * repeated int32 usage_ids = 33;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getUsageIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 33));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setUsageIdsList = function(value) {
  return jspb.Message.setField(this, 33, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addUsageIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 33, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearUsageIdsList = function() {
  return this.setUsageIdsList([]);
};


/**
 * repeated int32 occupation_ids = 34;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getOccupationIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 34));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setOccupationIdsList = function(value) {
  return jspb.Message.setField(this, 34, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addOccupationIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 34, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearOccupationIdsList = function() {
  return this.setOccupationIdsList([]);
};


/**
 * repeated int32 industry_ids = 35;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getIndustryIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 35));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setIndustryIdsList = function(value) {
  return jspb.Message.setField(this, 35, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addIndustryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 35, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearIndustryIdsList = function() {
  return this.setIndustryIdsList([]);
};


/**
 * repeated int32 language_ids = 36;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getLanguageIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 36));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setLanguageIdsList = function(value) {
  return jspb.Message.setField(this, 36, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addLanguageIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 36, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearLanguageIdsList = function() {
  return this.setLanguageIdsList([]);
};


/**
 * repeated int32 file_type_ids = 37;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getFileTypeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 37));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setFileTypeIdsList = function(value) {
  return jspb.Message.setField(this, 37, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addFileTypeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 37, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearFileTypeIdsList = function() {
  return this.setFileTypeIdsList([]);
};


/**
 * optional string layout = 38;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getLayout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setLayout = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional int32 master_category_id = 39;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional int32 master_category_type_id = 40;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getMasterCategoryTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setMasterCategoryTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * repeated int32 technique_ids = 41;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getTechniqueIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 41));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setTechniqueIdsList = function(value) {
  return jspb.Message.setField(this, 41, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addTechniqueIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 41, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearTechniqueIdsList = function() {
  return this.setTechniqueIdsList([]);
};


/**
 * repeated int32 paper_size_ids = 42;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getPaperSizeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 42));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setPaperSizeIdsList = function(value) {
  return jspb.Message.setField(this, 42, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addPaperSizeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 42, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearPaperSizeIdsList = function() {
  return this.setPaperSizeIdsList([]);
};


/**
 * repeated int32 base_scope_ids = 43;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getBaseScopeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 43));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setBaseScopeIdsList = function(value) {
  return jspb.Message.setField(this, 43, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addBaseScopeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 43, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearBaseScopeIdsList = function() {
  return this.setBaseScopeIdsList([]);
};


/**
 * repeated int32 sex_ids = 44;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getSexIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 44));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setSexIdsList = function(value) {
  return jspb.Message.setField(this, 44, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addSexIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 44, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearSexIdsList = function() {
  return this.setSexIdsList([]);
};


/**
 * optional bool business_flag = 45;
 * @return {boolean}
 */
proto.service.SearchServiceRequest.prototype.getBusinessFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 45, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setBusinessFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 45, value);
};


/**
 * optional int32 provider_levels = 46;
 * @return {number}
 */
proto.service.SearchServiceRequest.prototype.getProviderLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProviderLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional string service_kind = 47;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getServiceKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setServiceKind = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * repeated int32 provider_level_ids = 48;
 * @return {!Array<number>}
 */
proto.service.SearchServiceRequest.prototype.getProviderLevelIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 48));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setProviderLevelIdsList = function(value) {
  return jspb.Message.setField(this, 48, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.addProviderLevelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 48, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.clearProviderLevelIdsList = function() {
  return this.setProviderLevelIdsList([]);
};


/**
 * optional string certification_divination_priority_display = 49;
 * @return {string}
 */
proto.service.SearchServiceRequest.prototype.getCertificationDivinationPriorityDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceRequest} returns this
 */
proto.service.SearchServiceRequest.prototype.setCertificationDivinationPriorityDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.SearchServiceReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.SearchServiceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.service.SearchServiceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.SearchServiceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchResultsList: jspb.Message.toObjectList(msg.getSearchResultsList(),
    proto.service.SearchServiceResult.toObject, includeInstance),
    searchCondition: (f = msg.getSearchCondition()) && proto.service.SearchServiceCondition.toObject(includeInstance, f),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    layout: jspb.Message.getFieldWithDefault(msg, 4, 0),
    servicePrMaxCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    servicePrRealCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.SearchServiceReply}
 */
proto.service.SearchServiceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.SearchServiceReply;
  return proto.service.SearchServiceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.SearchServiceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.SearchServiceReply}
 */
proto.service.SearchServiceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.service.SearchServiceResult;
      reader.readMessage(value,proto.service.SearchServiceResult.deserializeBinaryFromReader);
      msg.addSearchResults(value);
      break;
    case 2:
      var value = new proto.service.SearchServiceCondition;
      reader.readMessage(value,proto.service.SearchServiceCondition.deserializeBinaryFromReader);
      msg.setSearchCondition(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLayout(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServicePrMaxCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServicePrRealCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.SearchServiceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.SearchServiceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.SearchServiceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.service.SearchServiceResult.serializeBinaryToWriter
    );
  }
  f = message.getSearchCondition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.service.SearchServiceCondition.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLayout();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getServicePrMaxCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getServicePrRealCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * repeated SearchServiceResult search_results = 1;
 * @return {!Array<!proto.service.SearchServiceResult>}
 */
proto.service.SearchServiceReply.prototype.getSearchResultsList = function() {
  return /** @type{!Array<!proto.service.SearchServiceResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.SearchServiceResult, 1));
};


/**
 * @param {!Array<!proto.service.SearchServiceResult>} value
 * @return {!proto.service.SearchServiceReply} returns this
*/
proto.service.SearchServiceReply.prototype.setSearchResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.service.SearchServiceResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceResult}
 */
proto.service.SearchServiceReply.prototype.addSearchResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.service.SearchServiceResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.clearSearchResultsList = function() {
  return this.setSearchResultsList([]);
};


/**
 * optional SearchServiceCondition search_condition = 2;
 * @return {?proto.service.SearchServiceCondition}
 */
proto.service.SearchServiceReply.prototype.getSearchCondition = function() {
  return /** @type{?proto.service.SearchServiceCondition} */ (
    jspb.Message.getWrapperField(this, proto.service.SearchServiceCondition, 2));
};


/**
 * @param {?proto.service.SearchServiceCondition|undefined} value
 * @return {!proto.service.SearchServiceReply} returns this
*/
proto.service.SearchServiceReply.prototype.setSearchCondition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.clearSearchCondition = function() {
  return this.setSearchCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.SearchServiceReply.prototype.hasSearchCondition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.service.SearchServiceReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 layout = 4;
 * @return {number}
 */
proto.service.SearchServiceReply.prototype.getLayout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.setLayout = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 service_pr_max_count = 5;
 * @return {number}
 */
proto.service.SearchServiceReply.prototype.getServicePrMaxCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.setServicePrMaxCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 service_pr_real_count = 6;
 * @return {number}
 */
proto.service.SearchServiceReply.prototype.getServicePrRealCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceReply} returns this
 */
proto.service.SearchServiceReply.prototype.setServicePrRealCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.SearchServiceResult.prototype.toObject = function(opt_includeInstance) {
  return proto.service.SearchServiceResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.SearchServiceResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    service: (f = msg.getService()) && proto.service.ServiceData.toObject(includeInstance, f),
    provider: (f = msg.getProvider()) && proto.service.ProviderData.toObject(includeInstance, f),
    servicePr: (f = msg.getServicePr()) && proto.service.ServicePrData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.SearchServiceResult}
 */
proto.service.SearchServiceResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.SearchServiceResult;
  return proto.service.SearchServiceResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.SearchServiceResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.SearchServiceResult}
 */
proto.service.SearchServiceResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.service.ServiceData;
      reader.readMessage(value,proto.service.ServiceData.deserializeBinaryFromReader);
      msg.setService(value);
      break;
    case 2:
      var value = new proto.service.ProviderData;
      reader.readMessage(value,proto.service.ProviderData.deserializeBinaryFromReader);
      msg.setProvider(value);
      break;
    case 3:
      var value = new proto.service.ServicePrData;
      reader.readMessage(value,proto.service.ServicePrData.deserializeBinaryFromReader);
      msg.setServicePr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.SearchServiceResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.SearchServiceResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.SearchServiceResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getService();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.service.ServiceData.serializeBinaryToWriter
    );
  }
  f = message.getProvider();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.service.ProviderData.serializeBinaryToWriter
    );
  }
  f = message.getServicePr();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.service.ServicePrData.serializeBinaryToWriter
    );
  }
};


/**
 * optional ServiceData service = 1;
 * @return {?proto.service.ServiceData}
 */
proto.service.SearchServiceResult.prototype.getService = function() {
  return /** @type{?proto.service.ServiceData} */ (
    jspb.Message.getWrapperField(this, proto.service.ServiceData, 1));
};


/**
 * @param {?proto.service.ServiceData|undefined} value
 * @return {!proto.service.SearchServiceResult} returns this
*/
proto.service.SearchServiceResult.prototype.setService = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.SearchServiceResult} returns this
 */
proto.service.SearchServiceResult.prototype.clearService = function() {
  return this.setService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.SearchServiceResult.prototype.hasService = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ProviderData provider = 2;
 * @return {?proto.service.ProviderData}
 */
proto.service.SearchServiceResult.prototype.getProvider = function() {
  return /** @type{?proto.service.ProviderData} */ (
    jspb.Message.getWrapperField(this, proto.service.ProviderData, 2));
};


/**
 * @param {?proto.service.ProviderData|undefined} value
 * @return {!proto.service.SearchServiceResult} returns this
*/
proto.service.SearchServiceResult.prototype.setProvider = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.SearchServiceResult} returns this
 */
proto.service.SearchServiceResult.prototype.clearProvider = function() {
  return this.setProvider(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.SearchServiceResult.prototype.hasProvider = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ServicePrData service_pr = 3;
 * @return {?proto.service.ServicePrData}
 */
proto.service.SearchServiceResult.prototype.getServicePr = function() {
  return /** @type{?proto.service.ServicePrData} */ (
    jspb.Message.getWrapperField(this, proto.service.ServicePrData, 3));
};


/**
 * @param {?proto.service.ServicePrData|undefined} value
 * @return {!proto.service.SearchServiceResult} returns this
*/
proto.service.SearchServiceResult.prototype.setServicePr = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.SearchServiceResult} returns this
 */
proto.service.SearchServiceResult.prototype.clearServicePr = function() {
  return this.setServicePr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.SearchServiceResult.prototype.hasServicePr = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.ServiceData.repeatedFields_ = [27,28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ServiceData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ServiceData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ServiceData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    overview: jspb.Message.getFieldWithDefault(msg, 3, ""),
    catchphrase: jspb.Message.getFieldWithDefault(msg, 4, ""),
    head: jspb.Message.getFieldWithDefault(msg, 5, ""),
    body: jspb.Message.getFieldWithDefault(msg, 6, ""),
    openedDate: jspb.Message.getFieldWithDefault(msg, 7, 0),
    priceWot: jspb.Message.getFieldWithDefault(msg, 8, 0),
    serviceClass: jspb.Message.getFieldWithDefault(msg, 9, 0),
    unitTime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    videoType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    proServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    customizeFlag: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    stopFg: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    moviePriorityFlag: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    notWantDisplayFlag: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    fixLimit: jspb.Message.getFieldWithDefault(msg, 17, 0),
    proposalLimit: jspb.Message.getFieldWithDefault(msg, 18, 0),
    shipmentFlag: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    unitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    fullCorrespondenceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    favoriteCount: jspb.Message.getFieldWithDefault(msg, 22, 0),
    deliveryAverage: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    reservationAvailableFlag: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    availableOrder: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    videoServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    serviceImagesList: jspb.Message.toObjectList(msg.getServiceImagesList(),
    proto.service.ServiceImageData.toObject, includeInstance),
    serviceMoviesList: jspb.Message.toObjectList(msg.getServiceMoviesList(),
    proto.service.ServiceMovieData.toObject, includeInstance),
    ratings: (f = msg.getRatings()) && proto.service.RatingData.toObject(includeInstance, f),
    parentCategoryId: jspb.Message.getFieldWithDefault(msg, 30, 0),
    parentCategoryName: jspb.Message.getFieldWithDefault(msg, 31, ""),
    childCategoryId: jspb.Message.getFieldWithDefault(msg, 32, 0),
    childCategoryName: jspb.Message.getFieldWithDefault(msg, 33, ""),
    isFavorited: jspb.Message.getBooleanFieldWithDefault(msg, 34, false),
    performanceCount: jspb.Message.getFieldWithDefault(msg, 35, 0),
    customizeRequiredFlag: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
    masterParentCategoryId: jspb.Message.getFieldWithDefault(msg, 37, 0),
    masterParentCategoryName: jspb.Message.getFieldWithDefault(msg, 38, ""),
    masterChildCategoryId: jspb.Message.getFieldWithDefault(msg, 39, 0),
    masterChildCategoryName: jspb.Message.getFieldWithDefault(msg, 40, ""),
    masterCategoryTypeId: jspb.Message.getFieldWithDefault(msg, 41, 0),
    masterCategoryTypeName: jspb.Message.getFieldWithDefault(msg, 42, ""),
    certificationDivinationServiceFlag: jspb.Message.getBooleanFieldWithDefault(msg, 43, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ServiceData}
 */
proto.service.ServiceData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ServiceData;
  return proto.service.ServiceData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ServiceData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ServiceData}
 */
proto.service.ServiceData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverview(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatchphrase(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHead(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenedDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriceWot(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceClass(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnitTime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVideoType(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProServiceFlag(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomizeFlag(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStopFg(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoviePriorityFlag(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotWantDisplayFlag(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFixLimit(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProposalLimit(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShipmentFlag(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUnitPrice(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullCorrespondenceFlag(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFavoriteCount(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDeliveryAverage(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReservationAvailableFlag(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvailableOrder(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVideoServiceFlag(value);
      break;
    case 27:
      var value = new proto.service.ServiceImageData;
      reader.readMessage(value,proto.service.ServiceImageData.deserializeBinaryFromReader);
      msg.addServiceImages(value);
      break;
    case 28:
      var value = new proto.service.ServiceMovieData;
      reader.readMessage(value,proto.service.ServiceMovieData.deserializeBinaryFromReader);
      msg.addServiceMovies(value);
      break;
    case 29:
      var value = new proto.service.RatingData;
      reader.readMessage(value,proto.service.RatingData.deserializeBinaryFromReader);
      msg.setRatings(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentCategoryId(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentCategoryName(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildCategoryId(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setChildCategoryName(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorited(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerformanceCount(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomizeRequiredFlag(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterParentCategoryId(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterParentCategoryName(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterChildCategoryId(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterChildCategoryName(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryTypeId(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterCategoryTypeName(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCertificationDivinationServiceFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ServiceData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ServiceData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ServiceData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOverview();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCatchphrase();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHead();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOpenedDate();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getPriceWot();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getServiceClass();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getUnitTime();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getVideoType();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getProServiceFlag();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getCustomizeFlag();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getStopFg();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getMoviePriorityFlag();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getNotWantDisplayFlag();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getFixLimit();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getProposalLimit();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getShipmentFlag();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getUnitPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = message.getFullCorrespondenceFlag();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getFavoriteCount();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getDeliveryAverage();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getReservationAvailableFlag();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getAvailableOrder();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getVideoServiceFlag();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getServiceImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      proto.service.ServiceImageData.serializeBinaryToWriter
    );
  }
  f = message.getServiceMoviesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      proto.service.ServiceMovieData.serializeBinaryToWriter
    );
  }
  f = message.getRatings();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.service.RatingData.serializeBinaryToWriter
    );
  }
  f = message.getParentCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getParentCategoryName();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getChildCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      32,
      f
    );
  }
  f = message.getChildCategoryName();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getIsFavorited();
  if (f) {
    writer.writeBool(
      34,
      f
    );
  }
  f = message.getPerformanceCount();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getCustomizeRequiredFlag();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getMasterParentCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      37,
      f
    );
  }
  f = message.getMasterParentCategoryName();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getMasterChildCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      39,
      f
    );
  }
  f = message.getMasterChildCategoryName();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getMasterCategoryTypeId();
  if (f !== 0) {
    writer.writeInt32(
      41,
      f
    );
  }
  f = message.getMasterCategoryTypeName();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getCertificationDivinationServiceFlag();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.service.ServiceData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.service.ServiceData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string overview = 3;
 * @return {string}
 */
proto.service.ServiceData.prototype.getOverview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setOverview = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string catchphrase = 4;
 * @return {string}
 */
proto.service.ServiceData.prototype.getCatchphrase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setCatchphrase = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string head = 5;
 * @return {string}
 */
proto.service.ServiceData.prototype.getHead = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setHead = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string body = 6;
 * @return {string}
 */
proto.service.ServiceData.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 opened_date = 7;
 * @return {number}
 */
proto.service.ServiceData.prototype.getOpenedDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setOpenedDate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 price_wot = 8;
 * @return {number}
 */
proto.service.ServiceData.prototype.getPriceWot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setPriceWot = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 service_class = 9;
 * @return {number}
 */
proto.service.ServiceData.prototype.getServiceClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setServiceClass = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 unit_time = 10;
 * @return {number}
 */
proto.service.ServiceData.prototype.getUnitTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setUnitTime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 video_type = 11;
 * @return {number}
 */
proto.service.ServiceData.prototype.getVideoType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setVideoType = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool pro_service_flag = 12;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getProServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setProServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool customize_flag = 13;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getCustomizeFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setCustomizeFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool stop_fg = 14;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getStopFg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setStopFg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool movie_priority_flag = 15;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getMoviePriorityFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMoviePriorityFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool not_want_display_flag = 16;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getNotWantDisplayFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setNotWantDisplayFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional int32 fix_limit = 17;
 * @return {number}
 */
proto.service.ServiceData.prototype.getFixLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setFixLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 proposal_limit = 18;
 * @return {number}
 */
proto.service.ServiceData.prototype.getProposalLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setProposalLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional bool shipment_flag = 19;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getShipmentFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setShipmentFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional float unit_price = 20;
 * @return {number}
 */
proto.service.ServiceData.prototype.getUnitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setUnitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional bool full_correspondence_flag = 21;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getFullCorrespondenceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setFullCorrespondenceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional int32 favorite_count = 22;
 * @return {number}
 */
proto.service.ServiceData.prototype.getFavoriteCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setFavoriteCount = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional double delivery_average = 23;
 * @return {number}
 */
proto.service.ServiceData.prototype.getDeliveryAverage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setDeliveryAverage = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional bool reservation_available_flag = 24;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getReservationAvailableFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setReservationAvailableFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool available_order = 25;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getAvailableOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setAvailableOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional bool video_service_flag = 26;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getVideoServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setVideoServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * repeated ServiceImageData service_images = 27;
 * @return {!Array<!proto.service.ServiceImageData>}
 */
proto.service.ServiceData.prototype.getServiceImagesList = function() {
  return /** @type{!Array<!proto.service.ServiceImageData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.ServiceImageData, 27));
};


/**
 * @param {!Array<!proto.service.ServiceImageData>} value
 * @return {!proto.service.ServiceData} returns this
*/
proto.service.ServiceData.prototype.setServiceImagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.service.ServiceImageData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.ServiceImageData}
 */
proto.service.ServiceData.prototype.addServiceImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.service.ServiceImageData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.clearServiceImagesList = function() {
  return this.setServiceImagesList([]);
};


/**
 * repeated ServiceMovieData service_movies = 28;
 * @return {!Array<!proto.service.ServiceMovieData>}
 */
proto.service.ServiceData.prototype.getServiceMoviesList = function() {
  return /** @type{!Array<!proto.service.ServiceMovieData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.ServiceMovieData, 28));
};


/**
 * @param {!Array<!proto.service.ServiceMovieData>} value
 * @return {!proto.service.ServiceData} returns this
*/
proto.service.ServiceData.prototype.setServiceMoviesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.service.ServiceMovieData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.ServiceMovieData}
 */
proto.service.ServiceData.prototype.addServiceMovies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.service.ServiceMovieData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.clearServiceMoviesList = function() {
  return this.setServiceMoviesList([]);
};


/**
 * optional RatingData ratings = 29;
 * @return {?proto.service.RatingData}
 */
proto.service.ServiceData.prototype.getRatings = function() {
  return /** @type{?proto.service.RatingData} */ (
    jspb.Message.getWrapperField(this, proto.service.RatingData, 29));
};


/**
 * @param {?proto.service.RatingData|undefined} value
 * @return {!proto.service.ServiceData} returns this
*/
proto.service.ServiceData.prototype.setRatings = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.clearRatings = function() {
  return this.setRatings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.ServiceData.prototype.hasRatings = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional int32 parent_category_id = 30;
 * @return {number}
 */
proto.service.ServiceData.prototype.getParentCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setParentCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional string parent_category_name = 31;
 * @return {string}
 */
proto.service.ServiceData.prototype.getParentCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setParentCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int32 child_category_id = 32;
 * @return {number}
 */
proto.service.ServiceData.prototype.getChildCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setChildCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional string child_category_name = 33;
 * @return {string}
 */
proto.service.ServiceData.prototype.getChildCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setChildCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional bool is_favorited = 34;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getIsFavorited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setIsFavorited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 34, value);
};


/**
 * optional int32 performance_count = 35;
 * @return {number}
 */
proto.service.ServiceData.prototype.getPerformanceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setPerformanceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional bool customize_required_flag = 36;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getCustomizeRequiredFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setCustomizeRequiredFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional int32 master_parent_category_id = 37;
 * @return {number}
 */
proto.service.ServiceData.prototype.getMasterParentCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterParentCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional string master_parent_category_name = 38;
 * @return {string}
 */
proto.service.ServiceData.prototype.getMasterParentCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterParentCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional int32 master_child_category_id = 39;
 * @return {number}
 */
proto.service.ServiceData.prototype.getMasterChildCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterChildCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional string master_child_category_name = 40;
 * @return {string}
 */
proto.service.ServiceData.prototype.getMasterChildCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterChildCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional int32 master_category_type_id = 41;
 * @return {number}
 */
proto.service.ServiceData.prototype.getMasterCategoryTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterCategoryTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional string master_category_type_name = 42;
 * @return {string}
 */
proto.service.ServiceData.prototype.getMasterCategoryTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setMasterCategoryTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional bool certification_divination_service_flag = 43;
 * @return {boolean}
 */
proto.service.ServiceData.prototype.getCertificationDivinationServiceFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ServiceData} returns this
 */
proto.service.ServiceData.prototype.setCertificationDivinationServiceFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ProviderData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ProviderData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ProviderData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ProviderData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    identificationFlag: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    ndaConclusionFlag: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    lastLoginDate: jspb.Message.getFieldWithDefault(msg, 5, 0),
    proFlag: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    level: jspb.Message.getFieldWithDefault(msg, 7, 0),
    availableInstantPhone: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    profileIconPath: jspb.Message.getFieldWithDefault(msg, 9, ""),
    phoneTalking: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    phoneWait: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    isProviderAway: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    certificationDivinationFlag: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ProviderData}
 */
proto.service.ProviderData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ProviderData;
  return proto.service.ProviderData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ProviderData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ProviderData}
 */
proto.service.ProviderData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdentificationFlag(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNdaConclusionFlag(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastLoginDate(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProFlag(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvailableInstantPhone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileIconPath(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneTalking(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhoneWait(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsProviderAway(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCertificationDivinationFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ProviderData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ProviderData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ProviderData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ProviderData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIdentificationFlag();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getNdaConclusionFlag();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLastLoginDate();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getProFlag();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getAvailableInstantPhone();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getProfileIconPath();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPhoneTalking();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPhoneWait();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsProviderAway();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getCertificationDivinationFlag();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.service.ProviderData.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.service.ProviderData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool identification_flag = 3;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getIdentificationFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setIdentificationFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool nda_conclusion_flag = 4;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getNdaConclusionFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setNdaConclusionFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 last_login_date = 5;
 * @return {number}
 */
proto.service.ProviderData.prototype.getLastLoginDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setLastLoginDate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool pro_flag = 6;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getProFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setProFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 level = 7;
 * @return {number}
 */
proto.service.ProviderData.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool available_instant_phone = 8;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getAvailableInstantPhone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setAvailableInstantPhone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string profile_icon_path = 9;
 * @return {string}
 */
proto.service.ProviderData.prototype.getProfileIconPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setProfileIconPath = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool phone_talking = 10;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getPhoneTalking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setPhoneTalking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool phone_wait = 11;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getPhoneWait = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setPhoneWait = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_provider_away = 12;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getIsProviderAway = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setIsProviderAway = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool certification_divination_flag = 13;
 * @return {boolean}
 */
proto.service.ProviderData.prototype.getCertificationDivinationFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.ProviderData} returns this
 */
proto.service.ProviderData.prototype.setCertificationDivinationFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.ServicePrData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ServicePrData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ServicePrData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ServicePrData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServicePrData.toObject = function(includeInstance, msg) {
  var f, obj = {
    sprKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sprKeysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    servicePrUuid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ServicePrData}
 */
proto.service.ServicePrData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ServicePrData;
  return proto.service.ServicePrData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ServicePrData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ServicePrData}
 */
proto.service.ServicePrData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSprKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addSprKeys(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setServicePrUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ServicePrData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ServicePrData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ServicePrData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServicePrData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSprKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSprKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getServicePrUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string spr_key = 1;
 * @return {string}
 */
proto.service.ServicePrData.prototype.getSprKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServicePrData} returns this
 */
proto.service.ServicePrData.prototype.setSprKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string spr_keys = 2;
 * @return {!Array<string>}
 */
proto.service.ServicePrData.prototype.getSprKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.service.ServicePrData} returns this
 */
proto.service.ServicePrData.prototype.setSprKeysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.service.ServicePrData} returns this
 */
proto.service.ServicePrData.prototype.addSprKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.ServicePrData} returns this
 */
proto.service.ServicePrData.prototype.clearSprKeysList = function() {
  return this.setSprKeysList([]);
};


/**
 * optional string service_pr_uuid = 3;
 * @return {string}
 */
proto.service.ServicePrData.prototype.getServicePrUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServicePrData} returns this
 */
proto.service.ServicePrData.prototype.setServicePrUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ServiceImageData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ServiceImageData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ServiceImageData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceImageData.toObject = function(includeInstance, msg) {
  var f, obj = {
    imagePath: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ServiceImageData}
 */
proto.service.ServiceImageData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ServiceImageData;
  return proto.service.ServiceImageData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ServiceImageData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ServiceImageData}
 */
proto.service.ServiceImageData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImagePath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ServiceImageData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ServiceImageData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ServiceImageData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceImageData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImagePath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string image_path = 1;
 * @return {string}
 */
proto.service.ServiceImageData.prototype.getImagePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceImageData} returns this
 */
proto.service.ServiceImageData.prototype.setImagePath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ServiceMovieData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ServiceMovieData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ServiceMovieData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceMovieData.toObject = function(includeInstance, msg) {
  var f, obj = {
    providerSiteMovieId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ServiceMovieData}
 */
proto.service.ServiceMovieData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ServiceMovieData;
  return proto.service.ServiceMovieData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ServiceMovieData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ServiceMovieData}
 */
proto.service.ServiceMovieData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderSiteMovieId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ServiceMovieData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ServiceMovieData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ServiceMovieData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ServiceMovieData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProviderSiteMovieId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string provider_site_movie_id = 1;
 * @return {string}
 */
proto.service.ServiceMovieData.prototype.getProviderSiteMovieId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ServiceMovieData} returns this
 */
proto.service.ServiceMovieData.prototype.setProviderSiteMovieId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.RatingData.prototype.toObject = function(opt_includeInstance) {
  return proto.service.RatingData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.RatingData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RatingData.toObject = function(includeInstance, msg) {
  var f, obj = {
    indicator: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    ratingCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.RatingData}
 */
proto.service.RatingData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.RatingData;
  return proto.service.RatingData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.RatingData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.RatingData}
 */
proto.service.RatingData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setIndicator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRatingCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.RatingData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.RatingData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.RatingData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RatingData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndicator();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRatingCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional double indicator = 1;
 * @return {number}
 */
proto.service.RatingData.prototype.getIndicator = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.service.RatingData} returns this
 */
proto.service.RatingData.prototype.setIndicator = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 rating_count = 2;
 * @return {number}
 */
proto.service.RatingData.prototype.getRatingCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.RatingData} returns this
 */
proto.service.RatingData.prototype.setRatingCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.SearchServiceCondition.repeatedFields_ = [1,2,24,30];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.SearchServiceCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.service.SearchServiceCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.SearchServiceCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    categoriesList: jspb.Message.toObjectList(msg.getCategoriesList(),
    proto.service.Category.toObject, includeInstance),
    conditionOptionsList: jspb.Message.toObjectList(msg.getConditionOptionsList(),
    proto.service.ConditionOption.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 3, ""),
    perPage: jspb.Message.getFieldWithDefault(msg, 4, ""),
    serviceClass: jspb.Message.getFieldWithDefault(msg, 5, ""),
    serviceType: jspb.Message.getFieldWithDefault(msg, 6, ""),
    keyword: jspb.Message.getFieldWithDefault(msg, 7, ""),
    priceMin: jspb.Message.getFieldWithDefault(msg, 8, ""),
    priceMax: jspb.Message.getFieldWithDefault(msg, 9, ""),
    categoryId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sortBy: jspb.Message.getFieldWithDefault(msg, 11, ""),
    forceExclusion: jspb.Message.getFieldWithDefault(msg, 12, ""),
    publishedOnly: jspb.Message.getFieldWithDefault(msg, 13, ""),
    proFlag: jspb.Message.getFieldWithDefault(msg, 14, ""),
    proPriorityDisplay: jspb.Message.getFieldWithDefault(msg, 15, ""),
    customizeFlag: jspb.Message.getFieldWithDefault(msg, 16, ""),
    shipmentFlag: jspb.Message.getFieldWithDefault(msg, 17, ""),
    identificationFlag: jspb.Message.getFieldWithDefault(msg, 18, ""),
    ndaConclusionFlag: jspb.Message.getFieldWithDefault(msg, 19, ""),
    reservationAvailableFlag: jspb.Message.getFieldWithDefault(msg, 20, ""),
    includeNgService: jspb.Message.getFieldWithDefault(msg, 21, ""),
    excludeFullCorrespondence: jspb.Message.getFieldWithDefault(msg, 22, ""),
    videoServiceFlag: jspb.Message.getFieldWithDefault(msg, 23, ""),
    providerStatusesList: (f = jspb.Message.getRepeatedField(msg, 24)) == null ? undefined : f,
    layout: jspb.Message.getFieldWithDefault(msg, 25, ""),
    relatedCategoryId: jspb.Message.getFieldWithDefault(msg, 26, 0),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    masterCategoryTypeId: jspb.Message.getFieldWithDefault(msg, 28, ""),
    serviceKind: jspb.Message.getFieldWithDefault(msg, 29, ""),
    providerLevelIdsList: (f = jspb.Message.getRepeatedField(msg, 30)) == null ? undefined : f,
    certificationDivinationPriorityDisplay: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.SearchServiceCondition}
 */
proto.service.SearchServiceCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.SearchServiceCondition;
  return proto.service.SearchServiceCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.SearchServiceCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.SearchServiceCondition}
 */
proto.service.SearchServiceCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.service.Category;
      reader.readMessage(value,proto.service.Category.deserializeBinaryFromReader);
      msg.addCategories(value);
      break;
    case 2:
      var value = new proto.service.ConditionOption;
      reader.readMessage(value,proto.service.ConditionOption.deserializeBinaryFromReader);
      msg.addConditionOptions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerPage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceClass(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceMin(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceMax(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setForceExclusion(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishedOnly(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setProFlag(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setProPriorityDisplay(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomizeFlag(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setShipmentFlag(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationFlag(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setNdaConclusionFlag(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservationAvailableFlag(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setIncludeNgService(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcludeFullCorrespondence(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoServiceFlag(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.addProviderStatuses(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setLayout(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelatedCategoryId(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterCategoryId(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterCategoryTypeId(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceKind(value);
      break;
    case 30:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setProviderLevelIdsList(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificationDivinationPriorityDisplay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.SearchServiceCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.SearchServiceCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.SearchServiceCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SearchServiceCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.service.Category.serializeBinaryToWriter
    );
  }
  f = message.getConditionOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.service.ConditionOption.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPerPage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getServiceClass();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getServiceType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPriceMin();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPriceMax();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCategoryId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getForceExclusion();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPublishedOnly();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getProFlag();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getProPriorityDisplay();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCustomizeFlag();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getShipmentFlag();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getIdentificationFlag();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getNdaConclusionFlag();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getReservationAvailableFlag();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getIncludeNgService();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getExcludeFullCorrespondence();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getVideoServiceFlag();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getProviderStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      24,
      f
    );
  }
  f = message.getLayout();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getRelatedCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getMasterCategoryId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getMasterCategoryTypeId();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getServiceKind();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getProviderLevelIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      30,
      f
    );
  }
  f = message.getCertificationDivinationPriorityDisplay();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * repeated Category categories = 1;
 * @return {!Array<!proto.service.Category>}
 */
proto.service.SearchServiceCondition.prototype.getCategoriesList = function() {
  return /** @type{!Array<!proto.service.Category>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.Category, 1));
};


/**
 * @param {!Array<!proto.service.Category>} value
 * @return {!proto.service.SearchServiceCondition} returns this
*/
proto.service.SearchServiceCondition.prototype.setCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.service.Category=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.Category}
 */
proto.service.SearchServiceCondition.prototype.addCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.service.Category, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * repeated ConditionOption condition_options = 2;
 * @return {!Array<!proto.service.ConditionOption>}
 */
proto.service.SearchServiceCondition.prototype.getConditionOptionsList = function() {
  return /** @type{!Array<!proto.service.ConditionOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.ConditionOption, 2));
};


/**
 * @param {!Array<!proto.service.ConditionOption>} value
 * @return {!proto.service.SearchServiceCondition} returns this
*/
proto.service.SearchServiceCondition.prototype.setConditionOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.service.ConditionOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.ConditionOption}
 */
proto.service.SearchServiceCondition.prototype.addConditionOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.service.ConditionOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.clearConditionOptionsList = function() {
  return this.setConditionOptionsList([]);
};


/**
 * optional string page = 3;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setPage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string per_page = 4;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getPerPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string service_class = 5;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getServiceClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setServiceClass = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string service_type = 6;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getServiceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setServiceType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string keyword = 7;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string price_min = 8;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getPriceMin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setPriceMin = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string price_max = 9;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getPriceMax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setPriceMax = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string category_id = 10;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string sort_by = 11;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string force_exclusion = 12;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getForceExclusion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setForceExclusion = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string published_only = 13;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getPublishedOnly = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setPublishedOnly = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string pro_flag = 14;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getProFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setProFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string pro_priority_display = 15;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getProPriorityDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setProPriorityDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string customize_flag = 16;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getCustomizeFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setCustomizeFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string shipment_flag = 17;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getShipmentFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setShipmentFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string identification_flag = 18;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getIdentificationFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setIdentificationFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string nda_conclusion_flag = 19;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getNdaConclusionFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setNdaConclusionFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string reservation_available_flag = 20;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getReservationAvailableFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setReservationAvailableFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string include_ng_service = 21;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getIncludeNgService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setIncludeNgService = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string exclude_full_correspondence = 22;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getExcludeFullCorrespondence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setExcludeFullCorrespondence = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string video_service_flag = 23;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getVideoServiceFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setVideoServiceFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * repeated string provider_statuses = 24;
 * @return {!Array<string>}
 */
proto.service.SearchServiceCondition.prototype.getProviderStatusesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 24));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setProviderStatusesList = function(value) {
  return jspb.Message.setField(this, 24, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.addProviderStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 24, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.clearProviderStatusesList = function() {
  return this.setProviderStatusesList([]);
};


/**
 * optional string layout = 25;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getLayout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setLayout = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional int32 related_category_id = 26;
 * @return {number}
 */
proto.service.SearchServiceCondition.prototype.getRelatedCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setRelatedCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional string master_category_id = 27;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getMasterCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string master_category_type_id = 28;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getMasterCategoryTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setMasterCategoryTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string service_kind = 29;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getServiceKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setServiceKind = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * repeated int32 provider_level_ids = 30;
 * @return {!Array<number>}
 */
proto.service.SearchServiceCondition.prototype.getProviderLevelIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 30));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setProviderLevelIdsList = function(value) {
  return jspb.Message.setField(this, 30, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.addProviderLevelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 30, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.clearProviderLevelIdsList = function() {
  return this.setProviderLevelIdsList([]);
};


/**
 * optional string certification_divination_priority_display = 31;
 * @return {string}
 */
proto.service.SearchServiceCondition.prototype.getCertificationDivinationPriorityDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SearchServiceCondition} returns this
 */
proto.service.SearchServiceCondition.prototype.setCertificationDivinationPriorityDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.ConditionOption.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ConditionOption.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ConditionOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ConditionOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ConditionOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyCategoryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    min: (f = msg.getMin()) && proto.service.ConditionPrice.toObject(includeInstance, f),
    max: (f = msg.getMax()) && proto.service.ConditionPrice.toObject(includeInstance, f),
    relatedCategoryId: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ConditionOption}
 */
proto.service.ConditionOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ConditionOption;
  return proto.service.ConditionOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ConditionOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ConditionOption}
 */
proto.service.ConditionOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyCategoryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    case 4:
      var value = new proto.service.ConditionPrice;
      reader.readMessage(value,proto.service.ConditionPrice.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 5:
      var value = new proto.service.ConditionPrice;
      reader.readMessage(value,proto.service.ConditionPrice.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelatedCategoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ConditionOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ConditionOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ConditionOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ConditionOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyCategoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.service.ConditionPrice.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.service.ConditionPrice.serializeBinaryToWriter
    );
  }
  f = message.getRelatedCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string key_category_id = 1;
 * @return {string}
 */
proto.service.ConditionOption.prototype.getKeyCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.setKeyCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.service.ConditionOption.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string values = 3;
 * @return {!Array<string>}
 */
proto.service.ConditionOption.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional ConditionPrice min = 4;
 * @return {?proto.service.ConditionPrice}
 */
proto.service.ConditionOption.prototype.getMin = function() {
  return /** @type{?proto.service.ConditionPrice} */ (
    jspb.Message.getWrapperField(this, proto.service.ConditionPrice, 4));
};


/**
 * @param {?proto.service.ConditionPrice|undefined} value
 * @return {!proto.service.ConditionOption} returns this
*/
proto.service.ConditionOption.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.ConditionOption.prototype.hasMin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ConditionPrice max = 5;
 * @return {?proto.service.ConditionPrice}
 */
proto.service.ConditionOption.prototype.getMax = function() {
  return /** @type{?proto.service.ConditionPrice} */ (
    jspb.Message.getWrapperField(this, proto.service.ConditionPrice, 5));
};


/**
 * @param {?proto.service.ConditionPrice|undefined} value
 * @return {!proto.service.ConditionOption} returns this
*/
proto.service.ConditionOption.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.service.ConditionOption.prototype.hasMax = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 related_category_id = 6;
 * @return {number}
 */
proto.service.ConditionOption.prototype.getRelatedCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.ConditionOption} returns this
 */
proto.service.ConditionOption.prototype.setRelatedCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.ConditionPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.service.ConditionPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.ConditionPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ConditionPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.ConditionPrice}
 */
proto.service.ConditionPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.ConditionPrice;
  return proto.service.ConditionPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.ConditionPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.ConditionPrice}
 */
proto.service.ConditionPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.ConditionPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.ConditionPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.ConditionPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.ConditionPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.service.ConditionPrice.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ConditionPrice} returns this
 */
proto.service.ConditionPrice.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.service.ConditionPrice.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.ConditionPrice} returns this
 */
proto.service.ConditionPrice.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.Category.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.Category.prototype.toObject = function(opt_includeInstance) {
  return proto.service.Category.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.Category} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.Category.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isCurrent: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    subCategoriesList: jspb.Message.toObjectList(msg.getSubCategoriesList(),
    proto.service.SubCategory.toObject, includeInstance),
    textSeoName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phoneSeoName: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.Category}
 */
proto.service.Category.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.Category;
  return proto.service.Category.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.Category} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.Category}
 */
proto.service.Category.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrent(value);
      break;
    case 4:
      var value = new proto.service.SubCategory;
      reader.readMessage(value,proto.service.SubCategory.deserializeBinaryFromReader);
      msg.addSubCategories(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextSeoName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneSeoName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.Category.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.Category.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.Category} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.Category.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsCurrent();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getSubCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.service.SubCategory.serializeBinaryToWriter
    );
  }
  f = message.getTextSeoName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhoneSeoName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.service.Category.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.service.Category.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_current = 3;
 * @return {boolean}
 */
proto.service.Category.prototype.getIsCurrent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.setIsCurrent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated SubCategory sub_categories = 4;
 * @return {!Array<!proto.service.SubCategory>}
 */
proto.service.Category.prototype.getSubCategoriesList = function() {
  return /** @type{!Array<!proto.service.SubCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.SubCategory, 4));
};


/**
 * @param {!Array<!proto.service.SubCategory>} value
 * @return {!proto.service.Category} returns this
*/
proto.service.Category.prototype.setSubCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.service.SubCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.SubCategory}
 */
proto.service.Category.prototype.addSubCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.service.SubCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.clearSubCategoriesList = function() {
  return this.setSubCategoriesList([]);
};


/**
 * optional string text_seo_name = 6;
 * @return {string}
 */
proto.service.Category.prototype.getTextSeoName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.setTextSeoName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string phone_seo_name = 7;
 * @return {string}
 */
proto.service.Category.prototype.getPhoneSeoName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.Category} returns this
 */
proto.service.Category.prototype.setPhoneSeoName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.SubCategory.prototype.toObject = function(opt_includeInstance) {
  return proto.service.SubCategory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.SubCategory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SubCategory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isCurrent: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    textSeoName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phoneSeoName: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.SubCategory}
 */
proto.service.SubCategory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.SubCategory;
  return proto.service.SubCategory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.SubCategory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.SubCategory}
 */
proto.service.SubCategory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextSeoName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneSeoName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.SubCategory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.SubCategory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.SubCategory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.SubCategory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsCurrent();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTextSeoName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhoneSeoName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.service.SubCategory.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.SubCategory} returns this
 */
proto.service.SubCategory.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.service.SubCategory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SubCategory} returns this
 */
proto.service.SubCategory.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_current = 3;
 * @return {boolean}
 */
proto.service.SubCategory.prototype.getIsCurrent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.SubCategory} returns this
 */
proto.service.SubCategory.prototype.setIsCurrent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string text_seo_name = 4;
 * @return {string}
 */
proto.service.SubCategory.prototype.getTextSeoName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SubCategory} returns this
 */
proto.service.SubCategory.prototype.setTextSeoName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string phone_seo_name = 5;
 * @return {string}
 */
proto.service.SubCategory.prototype.getPhoneSeoName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.SubCategory} returns this
 */
proto.service.SubCategory.prototype.setPhoneSeoName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.RecommendServicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.service.RecommendServicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.RecommendServicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RecommendServicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    algorithm: jspb.Message.getFieldWithDefault(msg, 2, ""),
    businessFlag: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.RecommendServicesRequest}
 */
proto.service.RecommendServicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.RecommendServicesRequest;
  return proto.service.RecommendServicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.RecommendServicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.RecommendServicesRequest}
 */
proto.service.RecommendServicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlgorithm(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusinessFlag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.RecommendServicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.RecommendServicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.RecommendServicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RecommendServicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAlgorithm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBusinessFlag();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 service_id = 1;
 * @return {number}
 */
proto.service.RecommendServicesRequest.prototype.getServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.service.RecommendServicesRequest} returns this
 */
proto.service.RecommendServicesRequest.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string algorithm = 2;
 * @return {string}
 */
proto.service.RecommendServicesRequest.prototype.getAlgorithm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.RecommendServicesRequest} returns this
 */
proto.service.RecommendServicesRequest.prototype.setAlgorithm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool business_flag = 3;
 * @return {boolean}
 */
proto.service.RecommendServicesRequest.prototype.getBusinessFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.service.RecommendServicesRequest} returns this
 */
proto.service.RecommendServicesRequest.prototype.setBusinessFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.service.RecommendServicesReply.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.service.RecommendServicesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.service.RecommendServicesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.service.RecommendServicesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RecommendServicesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    algorithm: jspb.Message.getFieldWithDefault(msg, 1, ""),
    impressionParams: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recommendServicesList: jspb.Message.toObjectList(msg.getRecommendServicesList(),
    proto.service.SearchServiceResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.service.RecommendServicesReply}
 */
proto.service.RecommendServicesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.service.RecommendServicesReply;
  return proto.service.RecommendServicesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.service.RecommendServicesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.service.RecommendServicesReply}
 */
proto.service.RecommendServicesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlgorithm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpressionParams(value);
      break;
    case 3:
      var value = new proto.service.SearchServiceResult;
      reader.readMessage(value,proto.service.SearchServiceResult.deserializeBinaryFromReader);
      msg.addRecommendServices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.service.RecommendServicesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.service.RecommendServicesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.service.RecommendServicesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.service.RecommendServicesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlgorithm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImpressionParams();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecommendServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.service.SearchServiceResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional string algorithm = 1;
 * @return {string}
 */
proto.service.RecommendServicesReply.prototype.getAlgorithm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.RecommendServicesReply} returns this
 */
proto.service.RecommendServicesReply.prototype.setAlgorithm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string impression_params = 2;
 * @return {string}
 */
proto.service.RecommendServicesReply.prototype.getImpressionParams = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.service.RecommendServicesReply} returns this
 */
proto.service.RecommendServicesReply.prototype.setImpressionParams = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SearchServiceResult recommend_services = 3;
 * @return {!Array<!proto.service.SearchServiceResult>}
 */
proto.service.RecommendServicesReply.prototype.getRecommendServicesList = function() {
  return /** @type{!Array<!proto.service.SearchServiceResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.service.SearchServiceResult, 3));
};


/**
 * @param {!Array<!proto.service.SearchServiceResult>} value
 * @return {!proto.service.RecommendServicesReply} returns this
*/
proto.service.RecommendServicesReply.prototype.setRecommendServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.service.SearchServiceResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.service.SearchServiceResult}
 */
proto.service.RecommendServicesReply.prototype.addRecommendServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.service.SearchServiceResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.service.RecommendServicesReply} returns this
 */
proto.service.RecommendServicesReply.prototype.clearRecommendServicesList = function() {
  return this.setRecommendServicesList([]);
};


goog.object.extend(exports, proto.service);
